import { Checkbox } from '@fluentui/react-components';
import { BriefcaseRegular } from '@fluentui/react-icons';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../Button';
import { CommonHomeworkForm } from './CommonHomeworkForm';
import { SelectTeamsAssignmentWithResources } from './NewHomeworkDialog.interfaces';

export interface HomeworkViewProps {
  canCreateTeamsAssignment: boolean;
  selectedHomework?: SelectTeamsAssignmentWithResources;
  createAsTeamsAssignmentChecked: () => void;
  selectAssignmentButtonClicked: () => void;
  selectedHomeworkChanged?: (
    homework: SelectTeamsAssignmentWithResources,
  ) => void;
  selectedDate: Date;
}
export const HomeworkView: FC<HomeworkViewProps> = props => {
  const {
    canCreateTeamsAssignment,
    selectedHomework,
    createAsTeamsAssignmentChecked,
    selectAssignmentButtonClicked,
    selectedHomeworkChanged,
    selectedDate,
  } = props;
  const { t } = useTranslation();
  return (
    <div className="flex flex-col homeworkView">
      <Checkbox
        label={t('classbook:newassignment:dialog_create_teams', { defaultValue: 'Als Teams-Aufgabe anlegen' })}
        onChange={createAsTeamsAssignmentChecked}
        className="input"
        disabled={!canCreateTeamsAssignment}
      />
      <Button
        disabled={!canCreateTeamsAssignment}
        appearance="primary"
        icon={<BriefcaseRegular className="teamsAssignmentIcon" />}
        className="teamsAssignmentLinkBtn"
        onClick={selectAssignmentButtonClicked}
      >
        {t('classbook:newassignment:dialog_connect_teams', { defaultValue: 'Mit Teams verknüpfen' })}
      </Button>
      <CommonHomeworkForm
        selectedHomework={selectedHomework}
        selectedHomeworkChanged={selectedHomeworkChanged}
        minDate={selectedDate}
      />
    </div>
  );
};
